import { isBulkCategoryScopeReady, type BulkCategoryScope } from './bulkCategoryScope';

export function isBulkPreviewScopeAllowed(scope: BulkCategoryScope, _search: string): boolean {
  return isBulkCategoryScopeReady(scope);
}

export const bulkPreviewScopeHint =
  'Elegí al menos una categoría para incluir o excluir.';

export const bulkAllCatalogWarning =
  'Incluye todo el catálogo con precio. Filtrá si querés acotar.';
